import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Loader from 'components/smallStatic/Loader';

const PrivateRoute = ({ children }) => {
  const { user } = useAuthenticator(context => [context.user]);
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const session = await fetchAuthSession();

        const hasTokens = !!(
          session.tokens?.accessToken && session.tokens?.idToken
        );

        setIsAuthenticated(hasTokens);
      } catch (error) {
        console.error('Auth check error:', error);
        setIsAuthenticated(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkAuth();
  }, [user]);

  //** We only show the loader during the first check. */
  if (isChecking) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default PrivateRoute;
